import styled from 'styled-components';
export var StyledTabList = styled.div.withConfig({
  displayName: "TabListstyles__StyledTabList",
  componentId: "sc-1swf5dp-0"
})(["border-right:1px solid var(--dentsu-color-n300);display:flex;flex-direction:column;width:380px;padding:var(--dentsu-spacing-36) var(--dentsu-spacing-60);"]);